import React, { useEffect } from "react";
import { Table } from "react-bootstrap";
import { useFormatearCotizaciones } from "./../../../../Shared/Hooks/Custom.hooks";
import "./Historial.component.scss";

const HistorialComponent = ({ cotizaciones = [] }) => {
  const [cotizacionesF, setDatos] = useFormatearCotizaciones(cotizaciones);

  useEffect(() => {
    setDatos(cotizaciones);
  }, [cotizaciones]);

  return (
    <Table striped bordered={false} hover size="sm">
      <thead>
        <tr className="text-center text-secondary">
          <th>Nro.</th>
          <th>Estatus</th>
          <th>Fecha</th>
          <th>Cantidad</th>
          <th>Total</th>
        </tr>
      </thead>
      <tbody>
        {cotizacionesF.map((cotizacion) => {
          const { datos } = cotizacion;
          return (
            <tr key={cotizacion.id}>
              <td className="text-left">{datos.Codigo}</td>
              <td className="text-center">{datos.Estatus}</td>
              <td className="text-center">{datos.Fecha_Creacion}</td>
              <td className="text-center">{datos.Cantidad}</td>
              <td className="text-right">{datos.Total}</td>
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
};

export default HistorialComponent;
